module.exports = __webpack_public_path__ + "img/1.06602646.jpg";